import genericErrorModal from "./functions/erroGenerico";
import escolhaCadeiaProdutiva from "./functions/escolhaCadeiaProdutiva";
import videoModal from "./functions/video";
import gallery from "./functions/gallery";
import heyzine from "./functions/heyzine";
import * as mainHeader from "../_src/sections/header/main/index";

const DOM = {
    body: "body",
    modal: ".modal-container",
    closeModalBtn: "[data-action=close-modal]",
};

export async function getModalByTemplate(modal, data = null, arrayOfObjects = null) {
  let modalContainerEl = document.querySelector(DOM.modal);

  var formData = new FormData();

  if (data !== null) {
    Object.entries(data).forEach((entry) => {
      const [key, value] = entry;
      formData.append(key, value);
    });
  }

  if (arrayOfObjects !== null) {
    formData.append("arrayOfObjects", JSON.stringify(arrayOfObjects.data));
  }

  let modalTemplate = await (await fetch(`/modal/${modal}`, {
      method: "POST",
      body: formData
  })).text();

  modalContainerEl.innerHTML = modalTemplate;
  document.querySelector(DOM.modal).style.display = "block";

  selectModal(modal, data);
  closeModal();
}

export function selectModal(modal, data) {
  let modalFunctions = {
    "video": videoModal,
    "generic-error": genericErrorModal,
    "escolha-cadeia-produtiva": escolhaCadeiaProdutiva,
    "gallery": gallery,
    "heyzine": heyzine
  };

  if(data) {
    modalFunctions[modal] && modalFunctions[modal](data);
  } else {
    modalFunctions[modal] && modalFunctions[modal]();
  }
}

export function closeModal() {
  let modalContainerEl = document.querySelector(DOM.modal);

  var closeMenuClickOutside = function(event) {
    if (event.target.closest("#modal-main-content") == null) {
      closeMenu();
    }
  }

  var closeMenuKeyDon = function(event) {
    if (event.code == "Escape") {
      closeMenu();
    }
  }

  function closeMenu() {
    modalContainerEl.innerHTML = "";
    modalContainerEl.style.display = "none";
    mainHeader.closeHeaderSubMenu();
    document.removeEventListener("keydown", closeMenuKeyDon);
    document.removeEventListener("click", closeMenuClickOutside);
  }

  document.addEventListener("keydown", closeMenuKeyDon);
  document.addEventListener("click", closeMenuClickOutside);
  if (document.querySelector(DOM.closeModalBtn)) {
    document.querySelector(DOM.closeModalBtn).addEventListener("click", closeMenu);
  }
}

export function modalVideo() {
  const DOM = {
    seletedVideo: null,
    videos: document.querySelectorAll("[data-action=open-video-modal]"),
  }

  DOM.videos.forEach(video => {
    video.addEventListener("click", (el) => {
      DOM.seletedVideo = el.currentTarget;
      openModal();
    })
  });

  function openModal() {
    getModalByTemplate("video", { url: DOM.seletedVideo.dataset.url });
  }
}

if (document.querySelector("[data-action=open-video-modal]")) {
  modalVideo();
}
